import { useEffect, useState } from 'preact/hooks';

export const useAnimation = (isFavourited: boolean) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // If we just became favourited, trigger the sparkle animation
    if (isFavourited) {
      setShouldAnimate(true);

      // Remove the animation class after a short delay, so
      // it can be re-triggered next time if unfavourited -> favourited again
      const timer = setTimeout(() => {
        setShouldAnimate(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isFavourited]);

  return { shouldAnimate, setShouldAnimate };
};
